import React from 'react';
import Btn, { BtnModifier } from '../../../components/molecules/Btn';
import { Namespace } from '../../../translation/namespace';
import { Icons } from '../../../components/atoms/SVG';
import { FileUploadResponseErrors } from '../../../_lib/FileUpload';
import { InteractionStatus } from '../../../types/InteractionStatus';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { TooltipPlacement } from '../../../components/atoms/Tooltip';
import { SonApiResponse } from '../../../types/api/SonApiResponse';

type ThreadPostAttachmentsError = {
  postId: string;
  errors: SonApiResponse[];
  resetErrors: () => void;
};

/**
 * A List of Errors received via WS that will be displayed on a post after a user uploads invalid files.
 */
export function ThreadPostAttachmentsError({ postId, errors, resetErrors }: ThreadPostAttachmentsError) {
  const { t } = useSonTranslation('Posts');

  const id = `thread-attached-files-error-${postId}`;

  return (
    <div className="thread__attachements-error-box" id={id}>
      <div className="thread__attachements-error-box-inner">
        <h5 className="thread__attachements-error-headline font-bold-15-19">
          {t('default.editor.status.invalidFiles')}
        </h5>
        <FileUploadResponseErrors status={InteractionStatus.FAIL} response={{ data: errors }} />
      </div>
      <div className="thread__attachements-error-box-close">
        <Btn
          text={t(`${Namespace.phrases}:close`)}
          titleText={t(`${Namespace.phrases}:close`)}
          hiddenText
          modifier={[BtnModifier.MINOR_ACTION, BtnModifier.TRANSPARENT]}
          svgSpriteId={Icons.DELETE_X_SMALL}
          tooltipPlacement={TooltipPlacement.TOP}
          onClick={resetErrors}
          aria-controls={id}
        />
      </div>
    </div>
  );
}
